module.exports = __webpack_public_path__ + "static/media/06 - Rim.c94228c3.wav";